export const init = () => {
    const observer = new MutationObserver(() => {
        const filter = document.querySelector('.js-filter:not([data-initialized="true"])');
        if (!filter) return;
        observer.disconnect();
        //filtering logic
        const filterInfo = {
            baseURL: filter.dataset.baseUrl,
            queryString: filter.dataset.qs
        };
        const checkboxes = filter.querySelectorAll('[data-param-name]');
        const categories = filter.querySelectorAll('.search-content__category');
        categories.forEach((item) => {
            const categoryDropdown = item.querySelector('.js-category-dropdown');
            const categoryContent = item.querySelector('.search-content__subcategory');
            const categoryContainer = filter.querySelector('.js-categories');
            if (item.classList.contains('active')) {
                categoryContent.style.maxHeight = categoryContent.scrollHeight + 'px';
                categoryContainer.style.maxHeight = categoryContainer.scrollHeight + categoryContent.scrollHeight + 'px';
                // console.log(categoryContainer.scrollHeight+categoryContent.scrollHeight);
            }
            categoryDropdown.addEventListener('click', () => {
                item.classList.toggle('active');
                if (categoryContent.style.maxHeight) {
                    categoryContent.removeAttribute('style');
                }
                else {
                    categoryContent.style.maxHeight = categoryContent.scrollHeight + 'px';
                    categoryContainer.style.maxHeight = categoryContainer.scrollHeight + categoryContent.scrollHeight + 'px';
                }
            }) 
        })
        let selected = [];
        checkboxes.forEach((checkbox) => { 
            if (window.innerWidth > 671) {
                checkbox.addEventListener('change', (e) => {
                    e.preventDefault();
                    if (document.querySelector('.loader')){
                        const loader = document.querySelector('.loader');
                        loader.classList.add('active');
                    }
                    if (checkbox.classList.contains('category-checkbox') && checkbox.checked === true) {
                        checkbox.classList.remove('checked-subs')
                        checkbox.parentElement.parentElement.querySelectorAll('[data-param-name]:not(.category-checkbox)').forEach((item) => {
                            item.checked = true;
                        })
                    }
                    if (checkbox.classList.contains('category-checkbox') && checkbox.checked === false) {
                        checkbox.parentElement.parentElement.querySelectorAll('[data-param-name]:not(.category-checkbox)').forEach((item) => {
                            item.checked = false;
                        })
                    }
                    if (checkbox.classList.contains('subcategory-checkbox')) {
                        filter.querySelectorAll('.subcategory-checkbox').forEach((item) => {
                            item.classList.remove('no-filter');
                        })
                        const subsChecked = checkbox.parentElement.parentElement.querySelectorAll('[data-param-name]:not(.category-checkbox)')
                        let isCheckedSubs = false;
                        let isAllSubsChecked = true;
                        subsChecked.forEach((item) => {
                            if (item.checked === true) {
                                isCheckedSubs = true;
                            }
                            else {
                                isAllSubsChecked = false;
                            } 
                        })
                        if (isCheckedSubs) {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').classList.add('checked-subs')
                        }
                        else {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').classList.remove('checked-subs')
                        }
                        if (isAllSubsChecked) {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').classList.remove('checked-subs')
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').checked = true;
                        }
                        else {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').checked = false;
                        }
                            
                    }
                    setTimeout(() => {
                        let checked = filter.querySelectorAll('[data-param-name]:checked');
                        const categoryChecked = Array.from(checked).filter(item => item.classList.contains('category-checkbox'))
                        // console.log(categoryChecked)
                        if (categoryChecked.length) {
                            categoryChecked.forEach((item) => {
                                item.parentElement.parentElement.querySelectorAll('.subcategory-checkbox').forEach((item) => {
                                    item.classList.add('no-filter')
                                })
                            })
                            checked = filter.querySelectorAll('[data-param-name]:checked:not(.no-filter)');
                        }
                        selected = Array.from(checked).map(x => x.dataset.paramName + " -" + x.value);
                        let pom;
                        let url = filterInfo.baseURL;
                        selected.forEach((item) => {
                            const split = item.split(" ");
                            if (pom != split[0]) {
                                pom = split[0];
                                url += "/" + pom + split[1];
                            } else {
                                url += split[1]; 
                            }
                        })
                        url += filterInfo.queryString;
                        location.href = url;
                    },2000);
                });
            }
            else {
                checkbox.addEventListener('change', () => {
                    if (checkbox.classList.contains('category-checkbox') && checkbox.checked === true) {
                        checkbox.classList.remove('checked-subs')
                        checkbox.parentElement.parentElement.querySelectorAll('[data-param-name]:not(.category-checkbox)').forEach((item) => {
                            item.checked = true;
                        })
                    }
                    if (checkbox.classList.contains('category-checkbox') && checkbox.checked === false) {
                        checkbox.parentElement.parentElement.querySelectorAll('[data-param-name]:not(.category-checkbox)').forEach((item) => {
                            item.checked = false;
                        })
                    }
                    if (checkbox.classList.contains('subcategory-checkbox')) {
                        filter.querySelectorAll('.subcategory-checkbox').forEach((item) => {
                            item.classList.remove('no-filter');
                        })
                        const subsChecked = checkbox.parentElement.parentElement.querySelectorAll('[data-param-name]:not(.category-checkbox)')
                        let isCheckedSubs = false;
                        let isAllSubsChecked = true;
                        subsChecked.forEach((item) => {
                            if (item.checked === true) {
                                isCheckedSubs = true;
                            }
                            else {
                                isAllSubsChecked = false;
                            } 
                        })
                        if (isCheckedSubs) {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').classList.add('checked-subs')
                        }
                        else {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').classList.remove('checked-subs')
                        }
                        if (isAllSubsChecked) {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').classList.remove('checked-subs')
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').checked = true;
                        }
                        else {
                            checkbox.parentElement.parentElement.parentElement.querySelector('.category-checkbox').checked = false;
                        }
                            
                    }
                })
                filter.querySelector('.confirm-mobile button').addEventListener('click', (e) => {
                    e.preventDefault();
                    if (document.querySelector('.loader')){
                        const loader = document.querySelector('.loader');
                        loader.classList.add('active');
                    }
                    setTimeout(() => {
                        let checked = filter.querySelectorAll('[data-param-name]:checked');
                        const categoryChecked = Array.from(checked).filter(item => item.classList.contains('category-checkbox'))
                        // console.log(categoryChecked)
                        if (categoryChecked.length) {
                            categoryChecked.forEach((item) => {
                                item.parentElement.parentElement.querySelectorAll('.subcategory-checkbox').forEach((item) => {
                                    item.classList.add('no-filter')
                                })
                            })
                            checked = filter.querySelectorAll('[data-param-name]:checked:not(.no-filter)');
                        }
                        selected = Array.from(checked).map(x => x.dataset.paramName + " -" + x.value);
                        let pom;
                        let url = filterInfo.baseURL;
                        selected.forEach((item) => {
                            const split = item.split(" ");
                            if (pom != split[0]) {
                                pom = split[0];
                                url += "/" + pom + split[1];
                            } else {
                                url += split[1]; 
                            }
                        })
                        url += filterInfo.queryString;
                        location.href = url;
                    },2000);
                });
            }
        });
        //end filtering logic
        //searching logic
        const searchSection = filter.querySelectorAll('.js-search-section');

        const toggleShowFilteredItems = function(item, content, searchInput) {
            // LOGIC FOR TOGGLE SHOW CATEGORIES 
            content.querySelectorAll('.search-content__category .checkbox:not(.search-content__subcategory .checkbox)').forEach((item) => {
                const value = item.innerText.toUpperCase();
                console.log(value); 
                if (value.indexOf(searchInput.value.toUpperCase()) > -1) {
                    item.parentElement.parentElement.classList.remove('hidden');  
                }
                else {
                    item.parentElement.parentElement.classList.add('hidden');
                }
            });
            // LOGIC FOR TOGGLE SHOW SUBCATEGORIES
            content.querySelectorAll('.search-content__subcategory .checkbox').forEach((item) => {
                const value = item.innerText.toUpperCase();
                if (value.indexOf(searchInput.value.toUpperCase()) > -1) {
                    item.parentElement.classList.remove('hidden');
                    item.parentElement.parentElement.parentElement.classList.remove('hidden')  
                }
                else {
                    item.parentElement.classList.add('hidden');
                }
            });
        };

        searchSection.forEach((item) => {
            const searchInput = item.querySelector('.js-search-input');
            const content = item.querySelector('.js-search-content');
            const deleteWriting = item.querySelector('.g-input__action--close');

            deleteWriting.addEventListener('click', (e) => {
                e.preventDefault();
                searchInput.value = ""; 
                toggleShowFilteredItems(item, content, searchInput); 
            })

            searchInput.addEventListener('keyup', (e) => {
                e.preventDefault(); 
                toggleShowFilteredItems(item, content, searchInput);   
            });
        });
        //end searching logic

        //hiding logic
        if (document.querySelector('.js-hide-button')) {
            const hideButton = document.querySelector('.js-hide-button');
            const mobileHideButton = filter.querySelector('.close-mobile');
            if (!hideButton.parentElement.classList.contains('webshop-filter__show')) {
                if (window.innerWidth < 1056) {
                    hideButton.innerHTML = hideButton.dataset.showText;
                }
                hideButton.addEventListener('click',(e) => {
                    e.preventDefault();
                    if (window.innerWidth > 1055) {
                        filter.classList.toggle('hide');
                        if (hideButton.dataset.shown === '0') {
                            hideButton.innerHTML = hideButton.dataset.hideText;
                            hideButton.dataset.shown = 1;
                        } 
                        else if (hideButton.dataset.shown === '1') {
                            hideButton.innerHTML = hideButton.dataset.showText;
                            hideButton.dataset.shown = 0;
                        }
                        if (document.querySelector('.js-filter-items')) {
                            document.querySelector('.js-filter-items').classList.toggle('full');
                        }
                    } else {
                        filter.classList.add('mobile-visible');
                    }
                });
            }
            else {
                hideButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    filter.classList.add('mobile-visible');
                })
            }
            mobileHideButton.addEventListener('click', (e) => {
                e.preventDefault();
                filter.classList.remove('mobile-visible');
            })
        }
        filter.dataset.initialized = 'true';
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}